import requestUni from "./request.js"

function GetUrlParam(paraName) {
    var url = document.location.toString();
    var arrObj = url.split("?");

    if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");

            if (arr != null && arr[0] == paraName) {
                return arr[1];
            }
        }
        return "";
    }
    else {
        return "";
    }
}
var openid=""
if(GetUrlParam('openid').indexOf("#/") == '-1'){
    openid=GetUrlParam('openid')
}else{
    openid=GetUrlParam('openid').split("#")[0]
}



//获取微信签名
export function GetWechatSing(params,callback) {
    // params.openid=openid
    console.log(params)
    params.openid=openid
    params.company_id=1
    requestUni({
        api:"/shop/",
        url: 'getWechatSing',
        method: 'GET',
        data:params,
        loading:'false',
        success:function(res){
            console.log(params)
            callback(res)
        }
    })
}


//获取个人信息
export function GetLeftUpInfo(params,callback) {
       requestUni({
        url: 'getLeftUpInfo',
        method: 'GET',
        data:{'openid':openid},
        success:function(res){
            callback(res)
        }
    })
}





// 1.1 当前营业数据
export function SaunaKanbanQuery(params,callback) {
    params.openid=openid
    console.log(params)

    requestUni({
        url: 'SaunaKanbanQuery',
        method: 'GET',
        data:params,
        success:function(res){
            console.log(params)
            callback(res)
        }
    })
}
// 1.2 昨日
export function SaunaPreshiftQuery(params,callback) {
    params.openid=openid
    requestUni({
        url: 'SaunaPreshiftQuery',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}

// 1.3 营业报警
export function SaunaWarningQuery(params,callback) {
    params.openid=openid
    requestUni({
        url: 'SaunaWarningQuery',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}

export function SaunaConsumeDetailQuery(params,callback) {
    params.openid=openid
    requestUni({
        url: 'SaunaConsumeDetailQuery',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}

export function Magician(params,callback) {
    params.openid=openid
    requestUni({
        url: 'Magician',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}




// 2.1 会籍营业
export function MemberKanbanQuery(params,callback) {
    params.openid=openid
    requestUni({
        url: 'MemberKanbanQuery',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}

// 2.2 会籍昨日
export function MemberPreshiftQuery(params,callback) {
    params.openid=openid
    requestUni({
        url: 'MemberPreshiftQuery',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}

// 2.3 收银员套现异常
export function MemberWarningCashQuery(params,callback) {
    params.openid=openid
    requestUni({
        url: 'MemberWarningCashQuery',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}

// 2.4
export function MemberWarningCardUsedQuery(params,callback) {
    params.openid=openid
    requestUni({
        url: 'MemberWarningCardUsedQuery',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}

// 2.5
export function MemberWarningCardTransQuery(params,callback) {
    params.openid=openid
    requestUni({
        url: 'MemberWarningCardTransQuery',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}


export function MemberWarningAccountAdjust(params,callback) {
    params.openid=openid
    requestUni({
        url: 'MemberWarningAccountAdjust',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}

export function MemberInfoChangeWarning(params,callback) {
    params.openid=openid
    requestUni({
        url: 'MemberInfoChangeWarning',
        method: 'GET',
        data:params,
        success:function(res){
            callback(res)
        }
    })
}


//////////////////
// WEBPACK FOOTER
// ./static/js/api.js
// module id = null
// module chunks = 